'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp2;

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Survey: {
    displayName: 'Survey'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/containers/Survey/Survey.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Helmet from 'react-helmet';


var Survey = _wrapComponent('Survey')((_dec = (0, _reactRedux.connect)(function () {
  return {};
}, { initialize: _reduxForm.initialize }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Survey, _Component);

  function Survey() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Survey);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Survey.__proto__ || (0, _getPrototypeOf2.default)(Survey)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (data) {
      window.alert('Data submitted! ' + (0, _stringify2.default)(data));
      _this.props.initialize('survey', {});
    }, _this.handleInitialize = function () {
      _this.props.initialize('survey', {
        name: 'Little Bobby Tables',
        email: 'bobby@gmail.com',
        occupation: 'Redux Wizard',
        currentlyEmployed: true,
        sex: 'male'
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Survey, [{
    key: 'render',
    value: function render() {
      return _react3.default.createElement(
        'div',
        { className: 'container' },
        _react3.default.createElement(
          'h1',
          null,
          'Survey'
        ),
        _react3.default.createElement(
          'p',
          null,
          'This is an example of a form in redux in which all the state is kept within the redux store. All the components are pure "dumb" components.'
        ),
        _react3.default.createElement(
          'p',
          null,
          'Things to notice:'
        ),
        _react3.default.createElement(
          'ul',
          null,
          _react3.default.createElement(
            'li',
            null,
            'No validation errors are shown initially.'
          ),
          _react3.default.createElement(
            'li',
            null,
            'Validation errors are only shown onBlur'
          ),
          _react3.default.createElement(
            'li',
            null,
            'Validation errors are hidden onChange when the error is rectified'
          ),
          _react3.default.createElement(
            'li',
            null,
            _react3.default.createElement(
              'code',
              null,
              'valid'
            ),
            ', ',
            _react3.default.createElement(
              'code',
              null,
              'invalid'
            ),
            ', ',
            _react3.default.createElement(
              'code',
              null,
              'pristine'
            ),
            ' and ',
            _react3.default.createElement(
              'code',
              null,
              'dirty'
            ),
            ' flags are passed with each change'
          ),
          _react3.default.createElement(
            'li',
            null,
            _react3.default.createElement(
              'em',
              null,
              'Except'
            ),
            ' when you submit the form, in which case they are shown for all invalid fields.'
          ),
          _react3.default.createElement(
            'li',
            null,
            'If you click the Initialize Form button, the form will be prepopupated with some values and the ',
            _react3.default.createElement(
              'code',
              null,
              'pristine'
            ),
            ' and ',
            _react3.default.createElement(
              'code',
              null,
              'dirty'
            ),
            ' flags will be based on those values.'
          )
        ),
        _react3.default.createElement(
          'p',
          null,
          'Pardon the use of ',
          _react3.default.createElement(
            'code',
            null,
            'window.alert()'
          ),
          ', but I wanted to keep this component stateless.'
        ),
        _react3.default.createElement(
          'div',
          { style: { textAlign: 'center', margin: 15 } },
          _react3.default.createElement(
            'button',
            { className: 'btn btn-primary', onClick: this.handleInitialize },
            _react3.default.createElement('i', { className: 'fa fa-pencil' }),
            ' Initialize Form'
          )
        ),
        _react3.default.createElement(
          'p',
          null,
          'The circles to the left of the inputs correspond to flags provided by ',
          _react3.default.createElement(
            'code',
            null,
            'redux-form'
          ),
          ': Touched, Visited, Active, and Dirty.'
        ),
        _react3.default.createElement(_components2.SurveyForm, { onSubmit: this.handleSubmit })
      );
    }
  }]);
  return Survey;
}(_react2.Component), _class2.propTypes = {
  initialize: _react2.PropTypes.func.isRequired
}, _temp2)) || _class));

exports.default = Survey;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Survey/Survey.js
// module id = 1214
// module chunks = 0